import { configureStore } from '@reduxjs/toolkit';
import authReducer      from './slices/authSlice';
import responderReducer from './slices/responderSlice';

export const store = configureStore({
  reducer: {
    auth:      authReducer,
    responder: responderReducer,
  },
});
